import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AnalyticsEvent {
  event: string;
  properties?: Record<string, any>;
}

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname);
  }, [location]);

  const trackPageView = (page: string) => {
    console.log('Page view:', page);
    // Here you can integrate with Google Analytics, Mixpanel, etc.
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('config', 'GA_MEASUREMENT_ID', {
        page_path: page,
      });
    }
  };

  const trackEvent = ({ event, properties }: AnalyticsEvent) => {
    console.log('Event:', event, properties);
    // Here you can integrate with your analytics service
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', event, properties);
    }
  };

  const trackUserAction = (action: string, details?: Record<string, any>) => {
    trackEvent({
      event: 'user_action',
      properties: {
        action,
        ...details,
        timestamp: new Date().toISOString(),
      },
    });
  };

  return { trackPageView, trackEvent, trackUserAction };
};
